import { ACTION_TYPES } from './types';
import { Action } from '../types';
import { Nullable } from 'utils/types';
import { CaseError } from 'modules/cm/domain/Case/Error';

export const setCaseErrors = (payload: Nullable<CaseError>): Action => ({
  type: ACTION_TYPES.SET_CASE_ERRORS,
  payload: [payload, null],
});
